// @ts-check
import axios from 'axios'

const BASE = '/api/work/telehealth/phone-book'

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['PhoneBookEntry']} PhoneBookEntry */
/** @typedef {Schemas['PhoneBookEntryCreateRequest']} PhoneBookEntryCreateRequest */
/** @typedef {Schemas['PhoneBookEntryDuplicate']} PhoneBookEntryDuplicate */
/** @typedef {Schemas['PatchedPhoneBookEntryUpdateRequest']} PhoneBookEntryUpdateRequest */

/**
 * POST /api/work/telehealth/phone-book/ — add an phone book entry. A number already in the
 * phone book rejects with 409 and an PhoneBookEntryDuplicate body carrying the existing entry.
 * @param {PhoneBookEntryCreateRequest} body
 * @returns {Promise<PhoneBookEntry>}
 */
export async function createPhoneBookEntry(body) {
  const { data } = await axios.post(`${BASE}/`, body)
  return data
}

/**
 * PATCH /api/work/telehealth/phone-book/{entryId}/ — update or deactivate (is_active=false) an entry (admin only).
 * @param {number} entryId
 * @param {PhoneBookEntryUpdateRequest} body
 * @returns {Promise<PhoneBookEntry>}
 */
export async function updatePhoneBookEntry(entryId, body) {
  const { data } = await axios.patch(`${BASE}/${entryId}/`, body)
  return data
}

/** @typedef {Schemas['PhoneBookDirectoryEntry']} PhoneBookDirectoryEntry */
/** @typedef {Partial<Schemas['PhoneBookSearchRequest']>} PhoneBookSearchRequest */
/**
 * POST /api/work/telehealth/phone-book/search/ — search the combined phone book: internal users
 * (from their assigned Kairon number) and contacts, each with a `type`. `query` is matched
 * server-side against name, role, number label and number digits; `types` defaults to both and
 * `include_inactive` (contacts only) to false.
 * @param {PhoneBookSearchRequest} [body]
 * @returns {Promise<PhoneBookDirectoryEntry[]>}
 */
export async function searchPhoneBook(body = {}) {
  const { data } = await axios.post(`${BASE}/search/`, body)
  return data
}
